import { ExtractRouteParams } from "@CommonUtils/routes";
import { ResponsePostMerchflows_merchflowId_ExportsBatch } from "../batch";

export const RouteGetMerchflows_merchflowId_ExportsBatch_batchId_ =
  "/merchflows/:merchflowId/exports/batch/:batchId";

export type ParamsGetMerchflows_merchflowId_ExportsBatch_batchId_ = ExtractRouteParams<
  typeof RouteGetMerchflows_merchflowId_ExportsBatch_batchId_
>;

export type ResponseGetMerchflows_merchflowId_ExportsBatch_batchId_ =
  ResponsePostMerchflows_merchflowId_ExportsBatch;
